 export class mdlCheckUrlReq{
    public RegNo: string;
    public InsuredId: string;
    public MobileNo: string;
    public LinkId: string;
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/mdlCheckUrlReq.ts